import { QueryString } from '../functions';

$(document).ready(function() {
    const filters = {
        isLoading: false,
        init() {
            $(document).on('click', '.type-filter', this, this.types);
            $(document).on('click', '.country-filter', this, this.countries);
            $(document).on('click', '.region-filter', this, this.regions);
            $(document).on('click', '.occasion-filter', this, this.occasions);
            $(document).on('click', '.culture-type-filter', this, this.cultureTypes);
        },
        cultureTypes(event) {
            const _this = event.data;
			let url = $(this).data('url');
			let id = $(this).data('id');

			let selectedValues = [];
			if (QueryString(null).ct) {
				selectedValues = QueryString(null).ct.split(',').map(Number);
			}

			let index = selectedValues.indexOf(id);
			if (index == -1) {
				selectedValues.push(id);
			} else {
				selectedValues.splice(index, 1);
			}

			let query = _this.getSelectedFiltersFromUrl(['ct']);
			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?ct=' + selectedValues.join(',');
				} else {
					query += '&ct=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
		},
        occasions(event) {
            const _this = event.data;
			let url = $(this).data('url');
			let id = $(this).data('id');

			let selectedValues = [];
			if (QueryString(null).o) {
				selectedValues = QueryString(null).o.split(',').map(Number);
			}

			let index = selectedValues.indexOf(id);
			if (index == -1) {
				selectedValues.push(id);
			} else {
				selectedValues.splice(index, 1);
			}

			let query = _this.getSelectedFiltersFromUrl(['o']);
			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?o=' + selectedValues.join(',');
				} else {
					query += '&o=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
		},
        regions(event) {
            const _this = event.data;
			let url = $(this).data('url');
			let id = $(this).data('id');

			let selectedValues = [];
			if (QueryString(null).r) {
				selectedValues = QueryString(null).r.split(',').map(Number);
			}

			let index = selectedValues.indexOf(id);
			if (index == -1) {
				selectedValues.push(id);
			} else {
				selectedValues.splice(index, 1);
			}

			let query = _this.getSelectedFiltersFromUrl(['r']);
			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?r=' + selectedValues.join(',');
				} else {
					query += '&r=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
		},
        countries(event) {
            const _this = event.data;
			let url = $(this).data('url');
			let id = $(this).data('id');

			let selectedValues = [];
			if (QueryString(null).c) {
				selectedValues = QueryString(null).c.split(',').map(Number);
			}

			let index = selectedValues.indexOf(id);
			if (index == -1) {
				selectedValues.push(id);
			} else {
				selectedValues.splice(index, 1);
			}

			let query = _this.getSelectedFiltersFromUrl(['c']);
			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?c=' + selectedValues.join(',');
				} else {
					query += '&c=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
		},
        types(event) {
            const _this = event.data;

			let url = $(this).data('url');

			let selectedValues = [];
			if (QueryString(null).t) {
				selectedValues = QueryString(null).t.split(',').map(Number);
			}

			let newVals = [];
			let ids = [];
			newVals.push($(this).data('id'));
			if ($(this).data('parent') == '0' && $(this).data('ids') != '') {
				ids = $(this).data('ids').split(',').map(Number);
				newVals = newVals.concat(ids);
			}

			let index = selectedValues.indexOf($(this).data('id'));
			if (index == -1) {
				if (newVals.length > 0) {
					for (var key in newVals) {
						let index = selectedValues.indexOf(newVals[key]);
						if (index == -1) {
							selectedValues.push(newVals[key]);
						}
					}
				}
			} else {
				selectedValues.splice(index, 1);
				//remove children if have
				if (ids.length > 0) {
					for (var key in ids) {
						let index = selectedValues.indexOf(ids[key]);
						if (index !== -1) {
							selectedValues.splice(index, 1);
						}
					}
				}
			}

			let query = _this.getSelectedFiltersFromUrl(['t']);
			if (selectedValues.length > 0) {
				if (query == '') {
					query += '?t=' + selectedValues.join(',');
				} else {
					query += '&t=' + selectedValues.join(',');
				}
			}

			window.location = url + query;
        },
		getSelectedFiltersFromUrl(exclude = []) {
			var query = '';

			var data = QueryString(null);
			for (var key of Object.keys(data)) {
				console.log(data[key], key);
				if (key != '') {
					if (exclude.indexOf(key) == -1) {
						if (query != '') {
							query += '&' + key + '=' + data[key];
						} else {
							query += '?' + key + '=' + data[key];
						}
					}
				}
			}

	    	return query;
		}
    };

    if ($('.category-page').length) {
        filters.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/filters.js